import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";

export default function SynergyTable() {
  return (
    <table className="KPIs-table">
      <tr>
        <th>Strategic Imperative</th>
        <th>KPI</th>
        <th>Unit</th>
        <th>Weight (%)</th>
        <th>
          <div>Target</div>
          <div>YTD</div>
        </th>
        <th>
          <div>Actual</div>
          <div>YTD</div>
        </th>
        <th>%Achieved</th>
        <th>Score</th>
        <th>
          <div>Actual</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Feb</div>
        </th>
        <th>
          <div>Mar</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Apr</div>
        </th>
        <th>
          <div>Actual</div>
          <div>May</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jun</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jul</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Aug</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Sep</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Oct</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Nov</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Dec</div>
        </th>
      </tr>
      <tr className="table-collapse">
        <td
          style={{
            border: "none",
            background: "#e28f60",
            whiteSpace: "nowrap",
          }}
        >
          ผนึกกำลังเครือ
        </td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ใช้สินค้าในเครือ CPF</td>
        <td>% จำนวนโรงอาหาร</td>
        <td>%</td>
        <td>7.5%</td>
        <td>-</td>
        <td>100%</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>100%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>สัดส่วนของ คนงาน, พนักงาน, ลูกค้า, Supplier ที่ใช้บริการ True</td>
        <td>% จำนวนที่ใช้ True</td>
        <td>%</td>
        <td>7.5%</td>
        <td>-</td>
        <td>60%</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>60%</td>
      </tr>
      <tr className="table-collapse">
        <td
          style={{
            border: "none",
            background: "#e28f60",
            whiteSpace: "nowrap",
          }}
        >
          พัฒนาคู่ค้านอกเครือ
        </td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>เติบโตในช่องทางเดิม</td>
        <td>%ยอดขายเติบโตช่องทางเดิม</td>
        <td>%</td>
        <td>4.0%</td>
        <td>(2%)</td>
        <td>27%</td>
        <td>1,834%</td>
        <td>5</td>
        <td></td>
        <td></td>
        <td>(4%)</td>
        <td></td>
        <td></td>
        <td>41%</td>
        <td></td>
        <td></td>
        <td>32%</td>
        <td></td>
        <td></td>
        <td>51%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>เพิ่มเติมลูกค้าใหม่</td>
        <td>สัดส่วนยอดขายของลูกค้าใหม่</td>
        <td>%</td>
        <td>1.0%</td>
        <td>1%</td>
        <td>3%</td>
        <td>200%</td>
        <td>5</td>
        <td></td>
        <td></td>
        <td>0%</td>
        <td></td>
        <td></td>
        <td>2%</td>
        <td></td>
        <td></td>
        <td>3%</td>
        <td></td>
        <td></td>
        <td>5%</td>
      </tr>
    </table>
  );
}
